import { CreateAndUpdateOperationParams } from 'api/types/params';
import { isYes, lodash, shiftDateByGmtOffset } from 'helpers';
import { OperationFormType } from 'modules/operation/common/forms/operationForm';

export const getOperationSubmitData = (
  values: OperationFormType,
  brokerTimezoneOffset: number
): CreateAndUpdateOperationParams => ({
  orderId: values.order!.value,
  executedAt: shiftDateByGmtOffset(values.executedAt, brokerTimezoneOffset),
  number: values.number,
  executionPlaceDirectoryRecordId: values.executionPlace!.value,
  executionMethod: values.executionMethod?.value!,
  isSpecializedTrade: isYes(values.isSpecializedTrade),
  traderId: values.trader?.value || '',
  counterpartyName: values.counterpartyName,
  quantity: values.quantity,
  netUnitPrice: values.netUnitPrice,
  unitPrice: values.unitPrice,
  accruedCouponIncome: values.accruedCouponIncome,
  volume: values.volume!,
  settlementDate: values.settlementDate,
  exchangeRate: values.exchangeRate,
  confirmationFileIds: lodash.compact(values.files?.map((file) => file.id)),
  additionalNotes: values.additionalNotes,
});
